var exports = {
  "u": "issueNumberText__8JDM6z",
  "d": "issueItem__HM4GBh",
};

module.exports = exports;
